import Stores from "@src/Stores";
import _ from "lodash";

const wsName = "umWebSockets";
export default class WebSocketsProxy {
  private accessor: any;

  ensureAccessor(): Promise<void> {    
    let attempt = 0;
    let maxAttempts = 10;

    const poll = (resolve: () => void) => {
      attempt++;
      this.accessor = window[wsName];
      if (this.accessor) {
        resolve();
      }
      else if (attempt > maxAttempts) {
        throw new Error(`${wsName} are missing after ${attempt}`);
      }
      else {
        console.log(`No ${wsName} yet on attempt ${attempt}`);
        setTimeout(_ => poll(resolve), 1000);
      }
    };

    return new Promise(poll);
  }

  async start() {
    this.ensureAccessor()
      .then(async _ => {
        await Stores.values.getValues()
        let umUrl = await Stores.values.getUserManagementUrl();
        let config = {
          userManagementUrl: umUrl,
          applicationName: Stores.values.applicationName,
          notifications: {
            rootElementId: 'notificationsRootElement',
            listSize: Stores.values.common.NotificationListSize
          }
        };

        let result = await this.accessor.startWithConfiguration(config);
        if (!result) {
          throw new Error("WebSockets start failed");
        }
      });    
  }

  stop() {
    if (this.accessor) {
      this.accessor.stop();
    }
  }

  subscribe = (messageType: string, handler: (e: CustomEvent) => void) => {
    this.ensureAccessor()
      .then(() => this.accessor.connection.subscribe(messageType, handler));
  }

  unsubscribe = (messageType: string, handler: (e: CustomEvent) => void) => {
    this.ensureAccessor()
      .then(() => this.accessor.connection.unsubscribe(messageType, handler));
  }
}
